import { COMMUNITY_PREFIX_PATH } from '../configs/AppConfig';
import { useCurrentMember } from '../redux/selector';
import { useLocation } from 'react-router-dom';

export const useCommunityPrefixPath = () => {
  const currentMember = useCurrentMember();
  if (!currentMember) {
    return COMMUNITY_PREFIX_PATH;
  }
  return communityPrefixPath(currentMember.communityId);
};

export const communityPrefixPath = (communityId: number) => {
  return `${COMMUNITY_PREFIX_PATH}/${communityId}`;
};

/**
 * Converts a document node path to client side URL.
 *
 * For example,
 * * `Documents`'s URL is `${COMMUNITY_PREFIX_PATH}/documents`.
 * * `Documents/Agenda/2020`'s URL is `${COMMUNITY_PREFIX_PATH}/documents/Agenda/2020`.
 */
export const useDocumentUrl = () => {
  const appPrefixPath = useCommunityPrefixPath();
  return (path: string) => `${appPrefixPath}/${['documents', ...path.split('/').slice(1)].join('/')}`;
};

export const useIsInMyUnit = () => {
  const appPrefixPath = useCommunityPrefixPath();
  const location = useLocation();
  return location.pathname.startsWith(`${appPrefixPath}/myUnit`);
};
